export default __webpack_public_path__ + "static/media/ic_card_gallery.76880dc6.svg";